import React from "react"
import train from "../assets/images/icons/train.svg"
import bus from "../assets/images/icons/bus.svg"
import car from "../assets/images/icons/car.svg"

export default React.memo(function Location() {
  return (
    <section className="container my-5" id="location">
      <div className="row px-3">
        <div className="col">
          <h2 className="mb-3 h1">Location</h2>
        </div>
      </div>
      <div className="row px-3 g-4">
        <div className="col-12 col-lg-4">
          <div className="pb-4">
            <p className="mb-0">
              <i className="text-muted">1142 W Madison St</i>
            </p>
            <p className="mb-0">
              <i className="text-muted">STE #402</i>
            </p>
            <p className="mb-0">
              <i className="text-muted">Chicago, IL 60607</i>
            </p>
          </div>
        </div>
        <div className="col-12 col-lg-8 d-flex align-items-start justify-content-center justify-content-lg-end">
          <iframe
            title="Urban Care Chiropractic location in Google maps."
            className="bg-light"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2968.467457918935!2d-87.660354!3d41.885239!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880e2cba3e5c7c3d%3A0xab2e1c0f53d7c08!2sUrban%20Care%20Chiropractic!5e0!3m2!1sen!2sus!4v1632778024821!5m2!1sen!2sus"
            style={{ width: "100%", height: "50vh", border: "0" }}
            frameBorder="0"
            allowFullScreen=""
            aria-hidden="false"
            tabIndex="0"
            id="map"
          />
        </div>
      </div>
    </section>
  )
})
